import { render, staticRenderFns } from "./GlobalProjects.vue?vue&type=template&id=7ddbd4ce"
import script from "./GlobalProjects.vue?vue&type=script&lang=js"
export * from "./GlobalProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports